import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const QuestionCard = ({ question, answer, onAnswerChange, onNext, onPrevious, isFirst, isLast }) => {
  const renderInput = () => {
    switch (question?.type) {
      case 'select':
        return (
          <Select
            options={question?.options}
            value={answer}
            onChange={onAnswerChange}
            placeholder={question?.placeholder}
            className="mt-4"
          />
        );
      
      case 'multiselect':
        return (
          <div className="mt-4 space-y-3">
            {question?.options?.map((option) => (
              <Checkbox
                key={option?.value}
                label={option?.label}
                checked={Array.isArray(answer) ? answer?.includes(option?.value) : false}
                onChange={(e) => {
                  const currentAnswers = Array.isArray(answer) ? answer : [];
                  if (e?.target?.checked) {
                    onAnswerChange([...currentAnswers, option?.value]);
                  } else {
                    onAnswerChange(currentAnswers?.filter(val => val !== option?.value));
                  }
                }}
              />
            ))}
          </div>
        );
      
      case 'number':
        return (
          <Input
            type="number"
            value={answer || ''}
            onChange={(e) => onAnswerChange(e?.target?.value)}
            placeholder={question?.placeholder}
            min={question?.min}
            max={question?.max}
            className="mt-4"
          />
        );
      
      case 'text':
        return (
          <Input
            type="text"
            value={answer || ''}
            onChange={(e) => onAnswerChange(e?.target?.value)}
            placeholder={question?.placeholder}
            className="mt-4"
          />
        );
      
      case 'textarea':
        return (
          <textarea
            value={answer || ''}
            onChange={(e) => onAnswerChange(e?.target?.value)}
            placeholder={question?.placeholder}
            rows={4}
            className="mt-4 w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
          />
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-brand-moderate p-8">
      <div className="mb-6">
        <div className="flex items-start space-x-3 mb-4">
          <div className="flex-shrink-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
            <Icon name={question?.icon} size={16} className="text-white" />
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold text-text-primary mb-2">
              {question?.title}
            </h3>
            <p className="text-text-secondary leading-relaxed">
              {question?.description}
            </p>
          </div>
        </div>
        
        {question?.helpText && (
          <div className="bg-surface rounded-lg p-4 mt-4">
            <div className="flex items-start space-x-2">
              <Icon name="HelpCircle" size={16} className="text-primary mt-0.5 flex-shrink-0" />
              <p className="text-sm text-text-secondary">{question?.helpText}</p>
            </div>
          </div>
        )}
      </div>
      <div className="mb-8">
        {renderInput()}
      </div>
      <div className="flex items-center justify-between">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={isFirst}
          iconName="ChevronLeft"
          iconPosition="left"
        >
          Previous
        </Button>
        
        <Button
          variant="default"
          onClick={onNext}
          disabled={!answer || (Array.isArray(answer) && answer?.length === 0)}
          iconName={isLast ? "CheckCircle" : "ChevronRight"}
          iconPosition="right"
          className="cta-primary"
        >
          {isLast ? "Complete Assessment" : "Next Question"}
        </Button>
      </div>
    </div>
  );
};

export default QuestionCard;